import { render, staticRenderFns } from "./JobsCreatedWidget.vue?vue&type=template&id=6172010e"
import script from "./JobsCreatedWidget.vue?vue&type=script&lang=js"
export * from "./JobsCreatedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6172010e')) {
      api.createRecord('6172010e', component.options)
    } else {
      api.reload('6172010e', component.options)
    }
    module.hot.accept("./JobsCreatedWidget.vue?vue&type=template&id=6172010e", function () {
      api.rerender('6172010e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/JobsCreatedWidget.vue"
export default component.exports